






























import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { Picture } from '@/components/atoms';

@Component({
  components: { Typography, Picture }
})
export default class RecommendationCard extends Vue {
  @Prop() src!: string;
  @Prop() text!: string;
  @Prop() buttonText!: string;
  @Prop() buttonTextColor!: string;
  @Prop({ default: '#fff' }) buttonBackgroundColor!: string;
  @Prop() backgroundColor!: string;
  @Prop() textColor!: string;
  @Prop() onClick!: () => void;
}
